module.exports = __webpack_public_path__ + "static/media/mdwa.faab8634.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/mdwa.woff?62057485
// module id = 45
// module chunks = 0